/* Caja del set de la PDP (snippets/oh-set.liquid).
   Pieza y complemento se compran por separado; el set es la alternativa, asi
   que marcar el set desmarca las piezas y marcar una pieza desmarca el set.
   Los precios viven en el markup (data-price de cada talla). */
(function () {
  'use strict';

  function addToCart(items) {
    // Mismo camino que "Completa tu look": el helper del theme abre el drawer.
    if (typeof window.addCartSize === 'function') {
      return window.addCartSize({ items: items }, items[0].id);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) { throw new Error(e.description || ''); });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh:opend', { bubbles: true }));
      document.dispatchEvent(new Event('cart:updated'));
      return r.json();
    });
  }

  function setup(root, cfg) {
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-oh-set-opt]'));
    var elTotal = root.querySelector('[data-oh-set-total]');
    var elNote = root.querySelector('[data-oh-set-note]');
    var elMsg = root.querySelector('[data-oh-set-msg]');
    var btn = root.querySelector('[data-oh-set-add]');

    function money(cents) {
      /* Dolares: se dejan los centavos cuando los hay, como money_without_trailing_zeros. */
      var units = Math.round(cents) / 100;
      var dec = Math.round(cents) % 100 ? 2 : 0;
      try {
        return '$' + units.toLocaleString(cfg.locale, { minimumFractionDigits: dec, maximumFractionDigits: dec });
      } catch (err) {
        return '$' + units.toFixed(dec);
      }
    }

    function check(opt) { return opt.querySelector('[data-oh-set-check]'); }

    function size(opt) {
      var input = opt.querySelector('input[type="radio"]:checked');
      if (!input) return null;
      return {
        id: parseInt(input.value, 10),
        price: parseInt(input.getAttribute('data-price'), 10) || 0,
        size: input.getAttribute('data-size') || ''
      };
    }

    function byKind(kind) {
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].getAttribute('data-kind') === kind) return opts[i];
      }
      return null;
    }

    function sync() {
      var total = 0;
      var notes = [];
      var ready = true;
      var any = false;

      for (var i = 0; i < opts.length; i++) {
        var opt = opts[i];
        var on = check(opt).checked;
        var pick = size(opt);
        opt.classList.toggle('is-on', on);

        var elPrice = opt.querySelector('[data-oh-set-price]');
        if (pick && elPrice) elPrice.textContent = money(pick.price);

        if (!on) continue;
        any = true;
        if (!pick) { ready = false; continue; }
        total += pick.price;
        notes.push(opt.getAttribute('data-short') + (pick.size ? ' ' + pick.size : ''));
      }

      // "ahorras": lo que costarian las dos piezas en las tallas elegidas menos el set.
      var set = byKind('set');
      var elSave = set && set.querySelector('[data-oh-set-save]');
      if (elSave) {
        var a = size(byKind('main'));
        var b = size(byKind('comp'));
        var s = size(set);
        var diff = (a && b && s) ? (a.price + b.price - s.price) : 0;
        elSave.textContent = diff > 0 ? ' · ' + cfg.text.save + ' ' + money(diff) : '';
      }

      if (elTotal) elTotal.textContent = money(total);
      if (elNote) elNote.textContent = notes.join(' · ');
      if (btn) btn.disabled = !any || !ready;
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (elMsg) elMsg.textContent = '';

      if (t.matches('[data-oh-set-check]')) {
        var opt = t.closest('[data-oh-set-opt]');
        var isSet = opt.getAttribute('data-kind') === 'set';
        if (t.checked) {
          // Set o piezas, nunca los dos.
          for (var i = 0; i < opts.length; i++) {
            var other = opts[i];
            if (other === opt) continue;
            if ((other.getAttribute('data-kind') === 'set') !== isSet) check(other).checked = false;
          }
        }
      } else if (t.type === 'radio') {
        // Elegir talla en una fila apagada la enciende: es lo que la persona quiere comprar.
        var row = t.closest('[data-oh-set-opt]');
        var c = row && check(row);
        if (c && !c.checked) {
          c.checked = true;
          c.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
      sync();
    });

    if (btn) {
      btn.addEventListener('click', function () {
        if (elMsg) elMsg.textContent = '';
        var items = [];
        for (var i = 0; i < opts.length; i++) {
          if (!check(opts[i]).checked) continue;
          var pick = size(opts[i]);
          if (!pick) {
            if (elMsg) elMsg.textContent = cfg.text.pick;
            return;
          }
          items.push({ id: pick.id, quantity: 1 });
        }
        if (!items.length) {
          if (elMsg) elMsg.textContent = cfg.text.none;
          return;
        }

        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = '...';

        Promise.resolve(addToCart(items))
          .then(function () {
            btn.textContent = label;
            btn.disabled = false;
          })
          .catch(function (err) {
            if (elMsg) elMsg.textContent = (err && err.message) ? err.message : cfg.text.error;
            btn.textContent = label;
            btn.disabled = false;
          });
      });
    }

    sync();
  }

  function init(root) {
    if (root.dataset.ohSetReady) return;
    var node = document.getElementById(root.getAttribute('data-cfg'));
    if (!node) return;
    var cfg;
    try {
      cfg = JSON.parse(node.textContent);
    } catch (err) {
      return;
    }
    root.dataset.ohSetReady = '1';
    setup(root, cfg);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-oh-set]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
